// extracted by mini-css-extract-plugin
export default {"tick-box":"Checkbox_tick-box__pOYo2","tick-box-on":"Checkbox_tick-box-on__mhfYb","sm":"Checkbox_sm__A16ZN","lg":"Checkbox_lg__ahATI"};